export const hotelPaymentMethods: {
  [key: string]: string;
} = {
  CREDIT_CARD: 'Tarjeta de crédito',
  CREDIT_CARD_WEB: 'Tarjeta de crédito (web)',
  WIRE_TRANSFER: 'Transferencia bancaria',
  CASH: 'Efectivo',
}